import { Button, Icon, Td, Text, Tr } from "@chakra-ui/react"
import { IterationStatusBadge } from "component/mapping/iteration/IterationStatusBadge"
import { IterationTypeBadge } from "component/mapping/iteration/IterationTypeBadge"
import { FC } from "react"
import { FiArrowRight } from "react-icons/fi"
import { Link as RouterLink } from "react-router-dom"
import { IterationListItem } from "type/mapping/iteration"
import { dateAsStringToDate, RU_DATE_FORMAT } from "util/formatting/date"
import { getIterationSummary } from "util/formatting/iterationSummary"

interface IterationRowProps {
  iteration: IterationListItem
}

// Серая подпись под основным текстом ячейки — как группа НСИ на странице
// проверки. mt — отступ от строки выше: от основного текста больше, между
// подписями (ИНН, договор) меньше
const Caption: FC<{ children?: string; mt?: number }> = ({ children, mt = 2 }) => (
  <Text mt={mt} fontSize="xs" color="gray.500" noOfLines={2} wordBreak="break-all">
    {children}
  </Text>
)

export const IterationRow: FC<IterationRowProps> = (props) => {
  const { iteration } = props

  const summary = getIterationSummary(iteration)
  const createdAt = dateAsStringToDate(iteration.created_at || undefined)
  const resultsUrl = `/mapping/result/iteration/${iteration.id}`

  return (
    <Tr _hover={{ bg: "gray.50" }}>
      {/* Документ, под ним ID проверки — по нему ищут из логов и сообщений BI */}
      <Td px={3} py={3}>
        <Text fontWeight="medium">{summary.title}</Text>
        <Caption>{iteration.id}</Caption>
      </Td>

      {/* Объект, под ним поставщик и договор */}
      <Td px={3} py={3}>
        <Text>{summary.object || "—"}</Text>
        {summary.details.map((detail, index) => (
          <Caption key={detail} mt={index === 0 ? 2 : 0.5}>
            {detail}
          </Caption>
        ))}
      </Td>

      <Td px={3} py={3}>
        <IterationTypeBadge size="sm" type={iteration.type || undefined} />
      </Td>

      <Td px={3} py={3}>
        {iteration.status ? (
          <IterationStatusBadge size="sm" status={iteration.status} />
        ) : (
          <Text color="gray.400">—</Text>
        )}
      </Td>

      {/* Дата и время — справочно, мельче основного текста */}
      <Td px={3} py={3} whiteSpace="nowrap" fontSize="sm" color="gray.600">
        <Text>{createdAt?.toLocaleDateString(RU_DATE_FORMAT)}</Text>
        <Text mt={1} fontSize="xs" color="gray.500">
          {createdAt?.toLocaleTimeString(RU_DATE_FORMAT, {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Text>
      </Td>

      {/* Ссылка, а не кнопка с переходом: открывается в этой вкладке, а
          Cmd/Ctrl+клик или колесо мыши — в новой */}
      <Td px={3} py={3} textAlign="right">
        <Button
          as={RouterLink}
          to={resultsUrl}
          size="sm"
          colorScheme="purple"
          fontWeight="medium"
          rightIcon={<Icon as={FiArrowRight} />}
        >
          Открыть
        </Button>
      </Td>
    </Tr>
  )
}
